import React, { useEffect, useState } from 'react'
import Input from '../../../../../components/Form/Input'
import ImageWithFallback from '../../../../components/ImageWithFallback'
import { END_POINT } from '../../../../../utils/constant'
import { Link, useParams } from 'react-router-dom'
import img1 from "../../../assets/anglais2.png"
import user1 from "../../../assets/bonnie-green.png"
import { CgArrowLeft } from 'react-icons/cg'



const StudentDetail = () => {
  const { id } = useParams();
  const [user, setUser] = useState({
    photo: "/path/to/fake-photo.jpg",
    firstName: "Jean",
    lastName: "Emilie Rakotonasandratra",
    email: "emilie.rakotonasandratra@example.com",
    phone: "+261 34 24 204 50",
    age: 25,
    position: "Développeur Full-Stack",
    courses: [
      {
        name: "Cours d'Anglais Intermédiaire",
        description: "Apprenez l'anglais à un niveau intermédiaire, améliorez vos compétences en conversation et en écriture.",
        startDate: "01-01-2025",
        duration: "3 mois",
        price: "40.000 Ariary",
        imgUrl: img1
      },
    //   {
    //     name: "Cours d'Anglais Avancé",
    //     description: "Cours pour les étudiants avancés, perfectionnez votre maîtrise de l'anglais, avec une attention particulière sur les nuances et la fluidité.",
    //     startDate: "01-04-2025",
    //     duration: "4 mois",
    //     price: "320€",
    //     imgUrl: "https://images.unsplash.com/photo-1584761040994-898f6b8f6ef1?crop=entropy&cs=tinysrgb&fit=max&ixid=MXwyMDg2OXwwfDF8c2VhcmNofDF8fGVuZ2xpc2h8ZW58MHx8fHwxNjgwNzg5NzY2&ixlib=rb-1.2.1&q=80&w=1080"
    //   }
    ]
  });

  useEffect(() => {
    // Simuler un appel API pour récupérer les données réelles
    // Exemple :
    // axios.get(`https://api.example.com/student/${id}`).then(response => setUser(response.data));
  }, [id]);

  return (
    <div className="layout-1">
 <Link to="/mira-formateur/etudiant" className="flex gap-2 items-center mb-4 text-primary-text text-sm">
            <CgArrowLeft/>
            <h1 className=''>Retour à la liste</h1>
          </Link>
      <div className="grid lg:grid-cols-7">
        {/* Informations de l'étudiant */}
        <div className="col-span-4 mt-10 bg-gray-50 px-4 pt-8 lg:mt-0">
          <p className="text-lg font-semibold">Informations de l'étudiant</p>
          <p className="text-gray-400">Consultez les informations détaillées de l'étudiant ci-dessous.</p>
          <div>
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Titre</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valeur</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 text-start">
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Photo</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <ImageWithFallback src={user1} alt="photo utilisateur" defaultType="user" className="w-24 h-24 rounded-md" />
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Nom</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.lastName}</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Email</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.email}</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Téléphone</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.phone}</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Âge</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.age} ans</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">Poste</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.position}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Formations suivies */}
        <div className="col-span-3 px-4 pt-8">
          <p className="text-lg font-semibold">Historique d'inscription</p>
          <p className="text-gray-400">Consultez les formations que l'étudiant suit actuellement.</p>
          <div className="mt-8 space-y-3 rounded-lg border bg-white  py-3 px-3 text-start">
            {user.courses.map((course, index) => (
              <div key={index} className="flex flex-col rounded-lg bg-white sm:flex-row">
                <img className="m-1 h-20 w-24 rounded-md border object-cover object-center" src={course.imgUrl} alt={course.name} />
                <div className="flex w-full flex-col px-4">
                  <span className="font-semibold">{course.name}</span>
                  {/* <p className="text-sm">{course.description}</p> */}
                  <p className="mt-auto font-bold">Prix : {course.price}</p>
                  {/* <p className="text-sm">Durée : {course.duration}</p> */}
                  <p className="text-sm">Début : {course.startDate}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentDetail;
